<style scoped lang="scss" type="text/scss">
.forecast-attendance-container {
    .top {
        margin: 1rem 0;
    }
}
</style>

<template>
    <div class="forecast-attendance-container">
        <block-divider>
            该页面用于统计本队预报名数量，正式报名人数不能超过该页面填报的人数
        </block-divider>
        <div class="top">
            <el-button type="primary" @click="addRow">新增</el-button>
        </div>
        <el-table
            :data="now_list"
            style="width: 100%"
            @cell-mouse-enter="handleCellEnter"
            @cell-mouse-leave="handleCellLeave"
        >
            <el-table-column type="index" label="编号"></el-table-column>
            <el-table-column prop="competition_name" label="赛项"></el-table-column>
            <el-table-column prop="school_name" label="学校"></el-table-column>
            <el-table-column prop="team_name" label="队伍"></el-table-column>
            <el-table-column prop="person_name" label="姓名">
                <template slot-scope="scope">
                    <el-input
                        v-if="scope.row.isEdit"
                        class="item"
                        v-model="scope.row.person_name"
                        placeholder="请输入内容"
                    ></el-input>
                    <div v-else class="txt">{{ scope.row.person_name }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="gender" label="性别">
                <template slot-scope="scope">
                    <el-input
                        v-if="scope.row.isEdit"
                        class="item"
                        v-model="scope.row.gender"
                        placeholder="请输入内容"
                    ></el-input>
                    <div v-else class="txt">{{ scope.row.gender }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="major" label="专业">
                <template slot-scope="scope">
                    <el-input
                        v-if="scope.row.isEdit"
                        class="item"
                        v-model="scope.row.major"
                        placeholder="请输入内容"
                    ></el-input>
                    <div v-else class="txt">{{ scope.row.major }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="major" label="角色">
                <template slot-scope="scope">
                    <el-select
                        v-if="scope.row.isEdit"
                        class="item"
                        v-model="scope.row.role"
                        placeholder="请选择角色"
                    >
                        <el-option label="老师" value="老师"></el-option>
                        <el-option label="学生" value="学生"></el-option>
                    </el-select>
<!--                    <el-input-->
<!--                        v-if="scope.row.isEdit"-->
<!--                        class="item"-->
<!--                        v-model="scope.row.role"-->
<!--                        placeholder="请输入内容"-->
<!--                    ></el-input>-->
                    <div v-else class="txt">{{ scope.row.role }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="danger"
                        @click="handleDeleteRow(scope.$index)"
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="top">
            <el-button type="primary" @click="submit">保存</el-button>
        </div>
    </div>
</template>

<script>
import BlockDivider from "../../../../../components/divider/block";
import {handleContestantApplications} from "../../../../../utils/data-handler";
import {mapState} from "vuex";
import _ from "lodash";

export default {
    name: "",
    components: {BlockDivider},
    data() {
        return {
            rules: {
                person_name: [
                    {required: true, message: '姓名不能为空', trigger: 'blur'},
                    {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                ],
                gender: [
                    {required: true, message: '性别不能为空', trigger: 'blur'},
                    {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                ],
                major: [
                    {required: true, message: '专业不能为空', trigger: 'blur'},
                    {min: 1, max: 200, message: '长度不能超过 200 个字', trigger: 'blur'}
                ],
            }
        };
    },
    computed: {
        ...mapState('player', {
            informationForecastAttendance: state => state.informationForecastAttendance,
            currentForecastAttendance: state => state.currentForecastAttendance,
            currentManagedPlayerId: state => state.currentManagedPlayerId,
            currentManagedPlayerInfo: state => state.currentManagedPlayerInfo,
        }),
        now_list () {
            let obj = []
            for (let i = 0; i < this.currentForecastAttendance.length; i++) {
                obj.push({
                    id: this.currentForecastAttendance[i].id,
                    competition_id: this.informationForecastAttendance.competition_id,
                    competition_name: this.informationForecastAttendance.competition_name,
                    school_id: this.informationForecastAttendance.school_id,
                    school_name: this.informationForecastAttendance.school_name,
                    team_id: this.informationForecastAttendance.team_id,
                    team_name: this.informationForecastAttendance.team_name,
                    person_name: this.currentForecastAttendance[i].person_name,
                    gender: this.currentForecastAttendance[i].gender,
                    major: this.currentForecastAttendance[i].major,
                    role: this.currentForecastAttendance[i].role,
                })
            }
            return obj;
        },
    },  //currentManagedPlayerId->informationForecastAttendance->currentForecastAttendance
    watch: {
        currentManagedPlayerInfo: {
            immediate: true,
            handler(currentManagedPlayerInfo) {
                if (
                    currentManagedPlayerInfo === null ||
                    currentManagedPlayerInfo === undefined
                )
                    return;
                this.loadCurrentForecastAttendance();
            },
        },
    },
    methods: {
        loadCurrentForecastAttendance() {
            this.$store.dispatch('player/loadCurrentForecastAttendance', this.informationForecastAttendance);
        },
        savePlayerForecastAttendance() {
            for (let i = 0; i < this.now_list.length; i++) {
                if (this.now_list[i].person_name === undefined || this.now_list[i].person_name === null || this.now_list[i].person_name === '') {
                    this.$message.error('请填写姓名');
                    return
                } else if (this.now_list[i].gender === undefined || this.now_list[i].gender === null || this.now_list[i].gender === '') {
                    this.$message.error('请填写性别');
                    return
                } else if (this.now_list[i].major === undefined || this.now_list[i].major === null || this.now_list[i].major === '') {
                    this.$message.error('请填写专业');
                    return
                }
            }
            let param = {
                competition_id: this.informationForecastAttendance.competition_id,
                school_id: this.informationForecastAttendance.school_id,
                team_id: this.informationForecastAttendance.team_id,
                temp_teams: this.now_list
            }
            this.$normalRequest('player/updatePlayerInformationForecastAttendance', param, '保存成功', true, this, 'requesting').then(_ => {
                this.loadCurrentForecastAttendance()
            }).catch(_ => {
            });
        },
        // 新增一行
        addRow() {
            const obj = {
                competition_name: this.informationForecastAttendance.competition_name,
                competition_id: this.informationForecastAttendance.competition_id,
                school_name: this.informationForecastAttendance.school_name,
                school_id: this.informationForecastAttendance.school_id,
                team_name: this.informationForecastAttendance.team_name,
                team_id: this.informationForecastAttendance.team_id,
                person_name: "",
                gender: "",
                major: "",
                role: "",
                isEdit: false,
            };
            this.now_list.push(obj);
        },
        /** 鼠标移入cell */
        handleCellEnter(row, column, cell, event) {
            row.isEdit = true;
        },
        /** 鼠标移出cell */
        handleCellLeave(row, column, cell, event) {
            // row.isEdit = false;
        },
        // 删除
        handleDeleteRow(index) {
            this.now_list.splice(index, 1);
        },
        submit() {
            this.$normalConfirm("【重要提示】", "请仔细核对“报名人数”数据，后续填报将以本次填报的“报名人数”作为上限，不可再增加！").then(() => {
                // 点击了确定
                this.savePlayerForecastAttendance();
            }, () => {
                // 点击了取消
            });
        },
    },
};
</script>
